import React, { FC } from "react";
import { Form, InputNumber, Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { FinanceRow } from "../../../../../../store/types/applicationBank.type";
import { FormInstance } from "antd/lib";

interface IFinanceTable {
  dataSource: FinanceRow[];
  form: FormInstance;
  isDisabled: boolean;
}

const financeValueFormatter = (value: number | string | undefined) => {
  return new Intl.NumberFormat("ru-RU").format(Number(value));
};

export const FinanceTable: FC<IFinanceTable> = (props) => {
  const { dataSource } = props;

  const columns: ColumnsType<FinanceRow> = [
    {
      title: "Наименование показателя",
      dataIndex: "title",
      width: "auto",
    },
    {
      title: "Код",
      dataIndex: "code",
      width: "70px",
    },
    {
      title: "Показатель",
      dataIndex: "lc",
      width: "160px",
      render: (value, row) => {
        if (row.code?.endsWith("00")) {
          return (
            <Form.Item
              name={["accountingBalance", "data", row.code, "lc"]}
              style={{ width: "100%", margin: 0 }}
            >
              <InputNumber
                formatter={financeValueFormatter}
                controls={false}
                disabled={props.isDisabled}
                style={{ width: "100%" }}
              />
            </Form.Item>
          );
        }
        if (row.code) {
          return (
            <Form.Item
              name={["accountingBalance", "data", row.code, "lc"]}
              style={{ width: "100%", marginBottom: 0 }}
            >
              <InputNumber
                formatter={financeValueFormatter}
                controls={false}
                disabled={props.isDisabled}
                style={{ width: "100%" }}
              />
            </Form.Item>
          );
        }
        return null;
      },
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={dataSource}
      bordered
      pagination={false}
    />
  );
};
